import { Card, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import { deleteContainer, leaveContainer } from 'src/services/container.service';
import Swal from "sweetalert2";
import config from "src/config";
import AddEditContainerModal from '../../modules/containers/AddEdit.modal';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { useNavigate } from "react-router-dom";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import containerMethods from "src/methods/container.methods";

const containerTypeMap = {
    'container': {
        name: 'Group',
        name_plural: 'Groups'
    },
    'department': {
        name: 'Department',
        name_plural: 'Departments'
    },
    'team': {
        name: 'Team',
        name_plural: 'Teams'
    },
    'project': {
        name: 'Project',
        name_plural: 'Projects'
    }
}


const styles = {
    fileNameStyles: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
}

class ContainerCard extends React.Component {

    getMapValue = (key) => {
        return containerTypeMap[this.state.type]?.[key] || '';
    }

    // promised setState
    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            type: this.props?.type || 'container',
            showAddEditContainerModal: false
        }
    }

    deleteContainer = async (container) => {

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            html: "You won't be able to revert this!<br /><br />All the files will be kept safe. Only the container will be deleted.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            // cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (confirm.isConfirmed) {
            // Call the delete API here
            const response = await deleteContainer(container._id);
            if (response.error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.error,
                    confirmButtonText: 'Ok',
                    confirmButtonColor: config.primaryColor
                });
                return;
            }
            Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: `${this.getMapValue('name')} has been deleted`,
                confirmButtonText: 'Ok',
                confirmButtonColor: config.primaryColor
            });
            await this.props.fetchContainers();
        }

    }

    leaveContainer = async (container) => {

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            html: "It needs to be shared again to access it back!<br /><br />Others will not be able to access files you own through the container. You won't be able to access files shared with you through this container. All the files you own will be kept safe.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            // cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, leave it!'
        });

        if (confirm.isConfirmed) {
            // Call the leave API here
            const response = await leaveContainer(container._id);
            if (response.error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.error,
                    confirmButtonText: 'Ok',
                    confirmButtonColor: config.primaryColor
                });
                return;
            }
            Swal.fire({
                icon: 'success',
                title: 'Left!',
                text: `You left the container ${this.getMapValue('name')}`,
                confirmButtonText: 'Ok',
                confirmButtonColor: config.primaryColor
            });
            await this.props.fetchContainers();
        }

    }

    menu = () => {
        return (
            <Menu
                id={`simple-menu-${this.props.container?._id}`}
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={() => this.setState({ anchorEl: null })}
                anchorReference="anchorPosition"
                anchorPosition={{ top: this.state.clickY, left: this.state.clickX }}
            >
                {(this.props?.container?.is_owner) ? (
                    <MenuItem
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.deleteContainer(this.props?.container);
                            this.setState({ anchorEl: null });
                        }}
                    >
                        <ListItemIcon>
                            <DeleteIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                    </MenuItem>
                ) : null}
                {(!this.props?.container?.is_owner) ? (
                    <MenuItem
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.leaveContainer(this.props?.container);
                            this.setState({ anchorEl: null });
                        }}
                    >
                        <ListItemIcon>
                            <LogoutIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Leave</ListItemText>
                    </MenuItem>
                ) : null}
            </Menu>
        );
    };

    handleCloseModal = () => {
        this.setState({ showAddEditContainerModal: false });
    };

    handleSaveModal = async () => {
        await this.setStateAsync({ showAddEditContainerModal: false });
        await this.props.fetchContainers();
    };

    render() {
        return (
            <>
                <Card variant='outlined'
                    sx={{
                        border: `2px solid ${this.props?.container?.color ?? 'white'}`,
                        padding: '8px',
                        cursor: 'pointer',
                    }}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        this.setState({
                            anchorEl: e.currentTarget,
                            clickX: e.clientX,
                            clickY: e.clientY
                        });
                    }}
                    onClick={() => {
                        this.props.navigate(`/files/view?containers=${encodeURIComponent(JSON.stringify([{ value: this.props?.container?._id, label: this.props?.container?.name }]))}`);
                        if (this.props?.onContainerClick) {
                            this.props.onContainerClick(this.props?.container);
                        }
                    }}
                >
                    <Stack direction="row" alignItems="center" justifyContent="space-between" >


                        <Stack direction="row" alignItems="center" spacing={1} flex={1} minWidth={0} width={'100%'}>
                            {containerMethods.getContainerIcon({}, { color: 'gray', fontSize: '20px', opacity: 0.5 })}
                            <Typography
                                variant="body1"
                                color="textPrimary" 
                                noWrap
                                sx={styles?.fileNameStyles}
                            >
                                {this.props?.container.name}
                            </Typography>
                        </Stack>

                        <Stack direction="row" spacing={1}>
                            {(this.props?.container?.automatically_created) ? (
                                <Tooltip title="Automatically created container">
                                    <AutoAwesomeIcon fontSize="small" style={{ verticalAlign: 'middle', marginLeft: '4px', opacity: 0.3 }} />
                                </Tooltip>
                            ) : null}
                            {(this.props?.container?.is_shared_outside_company) ? (
                                <Tooltip title="Shared outside company">
									<PeopleOutlinedIcon fontSize="small" style={{ color: 'lightgray' }} />
								</Tooltip>
                            ) : null}
                        </Stack>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                        <Stack direction="row" alignItems="center">
                            <Tooltip title="Modified">
                                <Typography variant="body2" color="textSecondary" component="div">
                                    {moment(this.props?.container?.updated_at).format(config?.DATETIMEOPTIONS?.DATE_TIME_FORMAT)}
                                </Typography>
                            </Tooltip>
                        </Stack>
                        {this.menu()}
                        <IconButton
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.setState({
                                    anchorEl: e.currentTarget,
                                    clickX: e.clientX,
                                    clickY: e.clientY,
                                });
                            }}
                            sx={{ p: 0 }}
                        >
                            <MoreHorizOutlinedIcon />
                        </IconButton>
                    </Stack>
                    <Stack direction="row">
                        {(!this.props?.container?.is_owner) ? (
                            <Stack direction="row" alignItems="center" sx={{ opacity: 0.3, minWidth: 0, flex: 1, flexGrow: 1 }}>
                                <ShieldOutlinedIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: '2px', opacity: 0.3 }} />
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="div"
                                    noWrap
                                    sx={{
										fontSize: 13,
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										minWidth: 0,
									}}
                                >
                                    {this.props?.container?.owner?.name ? (this.props?.container?.owner?.name + ' (' + this.props?.container?.owner?.username + ')') : this.props?.container?.owner?.username}
                                </Typography>
                            </Stack>
                        ) : (
                            <Stack direction="row" alignItems="center" sx={{ opacity: 0.3, minWidth: 0, flex: 1, flexGrow: 1 }}>
                                <ShieldOutlinedIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: '2px', opacity: 0.3 }} />
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="div"
                                    noWrap
                                    sx={{
										fontSize: 13,
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										minWidth: 0,
									}}
                                >
                                    {'You'}
                                </Typography>
                            </Stack>
                        )}

                        <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ opacity: 0.7, flexShrink: 0 }}>
                            <IconButton
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.setState({
                                        showAddEditContainerModal: true,
                                    });
                                }}
                                sx={{ p: 0 }}
                            >
                                <KeyboardArrowDownIcon />
                            </IconButton>
                        </Stack>
                    </Stack>
                </Card>
                {(this.state.showAddEditContainerModal) ? (
                    <AddEditContainerModal
                        open={this.state.showAddEditContainerModal}
                        onClose={this.handleCloseModal}
                        container={this.props?.container}
                        payload={{ type: this.state.type }}
                        onSave={this.handleSaveModal}
                    />
                ) : null}
            </>
        )
    }
}

export default function (props) {
    const navigate = useNavigate();

    return <ContainerCard {...props} navigate={navigate} />;
}
